import React, { useState } from "react";
import { Modal, Button, Typography } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

export default function ConfirmDeleteModal({
  open,
  title = "Confirm Delete",
  entityName,
  detailFields = [],
  onClose,
  onConfirm,
  loading: externalLoading,
}) {
  const [internalLoading, setInternalLoading] = useState(false);
  const loading =
    externalLoading !== undefined ? externalLoading : internalLoading;

  const handleConfirm = async () => {
    setInternalLoading(true);
    try {
      await onConfirm();
    } finally {
      setInternalLoading(false);
    }
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      footer={[
        <Button
          key="back"
          onClick={onClose}
          style={{ backgroundColor: "#D97A07", color: "#fff", border: "none" }}
        >
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          danger
          loading={loading}
          onClick={handleConfirm}
        >
          Delete{entityName ? ` ${entityName}` : ""}
        </Button>,
      ]}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "16px",
          padding: "16px 0",
        }}
      >
        <ExclamationCircleOutlined
          style={{ fontSize: "32px", color: "#dc3545" }}
        />
        <div>
          <Typography.Title level={5} style={{ margin: 0 }}>
            Are you sure?
          </Typography.Title>
          <Typography.Paragraph type="secondary">
            This action cannot be undone.
          </Typography.Paragraph>
          {detailFields.length > 0 && (
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "12px",
                borderRadius: "4px",
                marginTop: "12px",
              }}
            >
              {detailFields.map(({ label, value }) => (
                <p key={label} style={{ margin: "4px 0" }}>
                  <strong>{label}:</strong> {value}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
